import { Catalogs } from '@/typings/catalogs';
import jsonClient from './http-json';

class UtileriasRepository {
  path: string;
  constructor() {
    this.path = '/Utilerias/';
  }
  getCatalogos() {
    return jsonClient.get<Catalogs>(`${this.path}Obtener_catalogos`);
  }
}

export default new UtileriasRepository();
